/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, {Component} from 'react';
// material
import Group from 'material/group/group';
import ContentIndicator from 'material/embeds/contentindicator/contentindicator';
import SearchBar from 'material/searchbar/searchbar';
import Status from 'material/embeds/status/status';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/controlbar/controlbar_styles';
import ContentTypeSort from 'material/embeds/controlbar/contenttypesort/contenttypesort';
import ContentIndicatorSort from 'material/embeds/controlbar/contentindictatorsort/contentindicatorsort';



/* ========== ~~~~~~~~~~ CONTROL BAR : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class ControlBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            types: [],
            status: []
        }
    }

    handleSelectStatus = (status) => {
        this.setState({
            status: status
        });
        this.props.handleSelectStatus(status);
    };

    handleSelectType = (types) => {
        this.setState({
            types: types
        });
        this.props.handleSelectType(types);
    };

    render() {
        return (
            <div className={`controlbar ${this.props.classes.controlbar}`}>
                <SearchBar value={this.props.searchDefaultValue} placeholder={this.props.searchPlaceholder} onChange={this.props.searchOnChange} />
                <Group name={`filters`} direction={`horizontal`}>
                        <span className={`text`}>Showing: </span>
                        {!this.props.handleSelectStatus ? null :
                            <ContentIndicatorSort status={this.state.status} allStatus={[{value: 'true', name: 'online'}, {
                                value: 'false',
                                name: 'offline'
                            }]} handleSelect={this.handleSelectStatus}/>
                        }
                        {!this.props.handleSelectType ? null :
                            <ContentTypeSort types={this.state.types} allTypes={[{value: 'quiz', name: 'quiz'}, {
                                value: 'poll',
                                name: 'poll'
                            }, {value: 'story', name: 'story'}]} handleSelect={this.handleSelectType}/>
                        }
                </Group>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ControlBar);